export default __webpack_public_path__ + "static/media/educators3.0f29262e.jpg";